export const CHANGE_PAGE = 'app/CHANGE_PAGE';

export const changePage = payload => ({
  type: CHANGE_PAGE,
  payload,
});
